<template>
  <div
    class="order-card-wrap background-white rounded-regular shadow-light px-3 py-4"
  >
    <div class="heading d-flex flex-column flex-lg-row justify-content-lg-between align-items-center">
      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between text-center text-md-left align-items-center col-lg-9 px-0 px-lg-3">
        <span class="mt-3 mt-md-0">
          <label class="font-weight-bold d-block font-size-small mb-0">Assinatura</label>
          {{ subscription.entity.name }}
        </span>
        <span class="mt-3 mt-md-0">
          <label class="font-weight-bold d-block font-size-small mb-0 mr-md-3 mr-lg-4">Valor da assinatura</label>
          {{ (subscription.amount/100) | formatMoney }}
        </span>
        <span class="mt-3 mt-md-0">
          <label class="font-weight-bold d-block font-size-small mb-0 mr-md-3 mr-lg-4">Próxima cobrança</label>
          {{ subscription.next_billing_date | formatDate }}
        </span>
        <span class="mt-3 mt-md-0">
          <label class="font-weight-bold d-block font-size-small mb-0 mr-md-3 mr-lg-4">Status</label>
          {{ subscription.payment_status | formatPaymentStatus }}
        </span>
      </div>
      <div
        class="mt-4 mt-lg-0"
        v-if="expandable"
      >
        <Button
          class="btn-outline-color2"
          @click="open"
          v-if="!isOpen"
        >
          Ver detalhes
        </Button>
        <Button
          class="btn-outline-color2"
          @click="close"
          v-else
        >
          Fechar
        </Button>
      </div>
    </div>
    <div
      class="mx-auto col-md-10"
      v-if="isOpen"
    >
      <hr class="h-1 background-color2 my-4" />

      <template
        v-if="loader"
      >
        <Loader
          color="color2"
          size="big"
        />
      </template>
      <template v-else-if="fullSubscription">
        <h2 class="font-weight-bold text-color2 font-size-medium">
          Produtos
        </h2>
        <ul>
          <li>
            {{ fullSubscription.entity.name }}
          </li>
        </ul>
        <h2 class="font-weight-bold text-color2 font-size-medium">
          Dados da assinatura
        </h2>
        <ul class="pl-3">
          <li>
            <strong>Valor:</strong> {{ fullSubscription.amount/100 | formatMoney }}
          </li>
          <li>
            <strong>Forma de pagamento:</strong> {{ fullSubscription.payment_method | formatPaymentMethod }}
          </li>
          <template v-if="fullSubscription.payment_method === 'credit_card' && fullSubscription.card">
            <li>
              <strong>Bandeira do cartão:</strong> {{ fullSubscription.card.brand | formatCreditCardBrand }}
            </li>
            <li>
              <strong>Cartão de final:</strong> {{ fullSubscription.card.last_digits }}
            </li>
          </template>
          <li>
            <strong>Próxima cobrança:</strong> {{ fullSubscription.next_billing_date | formatDate }}
          </li>
          <li>
            <strong>Status da assinatura:</strong> {{ fullSubscription.payment_status | formatPaymentStatus }}
          </li>
          <li v-if="fullSubscription.payment_status === 'waiting_payment'">
            <strong>Data de vencimento:</strong> {{ fullSubscription.payment_expiration_date | formatDate }}
          </li>
        </ul>
        <!-- PAYMENT DATA -->
        <template v-if="fullSubscription.payment_status === 'waiting_payment'">
          <h2 class="font-weight-bold text-color2 font-size-medium">
            Pagamento pendente
          </h2>
          <template v-if="fullSubscription.latest_invoice.payment_method === 'boleto'">
            <ul class="pl-3">
              <li>
                <strong>Código de barras:</strong> {{ fullSubscription.latest_invoice.boleto_barcode }}
              </li>
              <li>
                <strong>URL do boleto:</strong> <a :href="fullSubscription.latest_invoice.boleto_url" class="link-color2" target="_blank">{{ fullSubscription.latest_invoice.boleto_url }}</a>
              </li>
              <li>
                <strong>Data de vencimento:</strong> {{ fullSubscription.latest_invoice.boleto_expiration_date | formatDate('DD/MM/YYYY HH:mm:ss') }}
              </li>
            </ul>
          </template>
          <template v-else-if="fullSubscription.latest_invoice.payment_method === 'pix'">
            <ul class="pl-3">
              <li>
                <div class="col-md-8 mx-auto mt-3">
                  <QRCodeCard
                    :code="fullSubscription.latest_invoice.pix_qr_code"
                  />
                </div>
              </li>
            </ul>
          </template>
        </template> <!-- END PAYMENT DATA -->

        <!-- ACTIONS -->
        <div class="text-center mt-5 d-flex flex-column flex-md-row justify-content-center" v-if="fullSubscription.payment_status === 'paid'">
          <div>
            <Button
              class="btn-outline-color2 mb-3 mb-md-0 mr-md-2"
              v-b-modal="`subscription-payment-${fullSubscription.id}`"
            >
              Alterar pagamento
            </Button>
            <SubscriptionPaymentMethodModal
              :subscription="fullSubscription"
              @payment-method-changed="getSubscription"
            />
          </div>
          <div>
            <Button
              class="btn-outline-color2"
              v-b-modal="`destroy-subscription-${fullSubscription.id}`"
            >
              Cancelar assinatura
            </Button>
            <DestroySubscriptionModal
              :subscription="fullSubscription"
              @subscription-destroyed="$emit('subscription-destroyed', fullSubscription.id)"
            />
          </div>
        </div> <!-- END ACTIONS -->
      </template>
    </div>
  </div>
</template>

<script>

import SubscriptionsService from '@/modules/subscriptions/services/subscriptions-service'

// import BaseIcon from '@/components/common/Icon/BaseIcon'
import Button from '@/components/common/Button/Button'
import DestroySubscriptionModal from '@/components/subscriptions/DestroySubscriptionModal'
import Loader from '@/components/common/Loader/Loader'
import QRCodeCard from '@/components/common/QRCode/QRCodeCard'
import SubscriptionPaymentMethodModal from '@/components/subscriptions/SubscriptionPaymentMethodModal'
// import WarningIcon from '@/components/common/Icon/WarningIcon'

export default {
  name: 'SubscriptionCard',
  props: ['subscription', 'expandable'],
  components: {
    // BaseIcon,
    Button,
    DestroySubscriptionModal,
    Loader,
    QRCodeCard,
    SubscriptionPaymentMethodModal
    // WarningIcon
  },
  data () {
    return {
      loader: false,
      isOpen: false,
      fullSubscription: null
    }
  },
  methods: {
    open () {
      this.isOpen = true
      if (!this.fullSubscription) this.getSubscription()
    },
    close () {
      this.isOpen = false
    },
    async getSubscription () {
      this.loader = true
      try {
        const subscription = await SubscriptionsService.getSubscription(this.subscription.id)
        this.fullSubscription = Object.assign({}, subscription)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
